import styled from 'styled-components'

const DevelopedFooterPlato = styled.div`
  text-transform: none;
  font-weight: 400;
  color: var(--font-muted);
  width: 130px;
  text-align: center;
  position: absolute;
  bottom: calc(0% + 1rem);
  left: 50%;
  transform: translateX(-50%);

`

export default DevelopedFooterPlato
